import React, { useContext, useEffect, useState } from 'react'
import SearchTable from 'src/components/searchTable'
import { CFormSwitch } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import moment from 'moment'
import ArtistCreateModal from './artistCreateModal'
import { activeArray, checkPermissions } from 'src/views/utils/helper'
import { GlobalContext } from '../../context/GlobalState'
import { PERMISSIONS } from '../../utils/permissions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import useAxios from 'axios-hooks'
import {
  ARTIST_CUSTOM_META_DATA_API,
  ARTIST_LIST_API,
  ARTIST_TYPE_LIST_API,
} from '../../utils/urls'
import { raiseToast } from '../../utils/helper'
import { AppContext } from '../../context/app'

const Artists = () => {
  const { setLoader, accountObj } = useContext(AppContext)
  const [selectedArtist, setSelectedArtist] = useState({})

  const [openModal, setOpenModal] = useState(false)
  const language = localStorage.getItem('language')
  const { userSessionObj } = useContext(GlobalContext)
  const defaultLangCheck = language === accountObj?.default_language
  const isCreateAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.ARTIST.CREATE) &&
    defaultLangCheck
  const isUpdateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.ARTIST.UPDATE,
  )

  const [{ data: artistList, loading: artistListLoading }, artistListCall] = useAxios(
    {
      url: ARTIST_LIST_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: createArtist, loading: createArtistLoading }, artistCreateCall] = useAxios(
    {
      url: ARTIST_LIST_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: updateArtist, loading: updateArtistLoading }, artistUpdateCall] = useAxios(
    {
      url: ARTIST_LIST_API,
      method: 'put',
    },
    { manual: true },
  )

  const [{ data: customMetadataList, loading: customMetadataLoading }, customMetadataCall] =
    useAxios(
      {
        url: ARTIST_CUSTOM_META_DATA_API,
        method: 'get',
      },
      { manual: true },
    )

  const [{ data: artistType, loading: artistTypeLoading }] = useAxios({
    url: ARTIST_TYPE_LIST_API,
    method: 'get',
  })

  useEffect(() => {
    customMetadataCall()
    artistListCall()
  }, [])

  useEffect(() => {
    setLoader(
      artistListLoading ||
        createArtistLoading ||
        updateArtistLoading ||
        artistTypeLoading ||
        customMetadataLoading,
    )
  }, [
    artistListLoading,
    createArtistLoading,
    updateArtistLoading,
    artistTypeLoading,
    customMetadataLoading,
  ])

  useEffect(() => {
    if (createArtist && createArtist.success) {
      artistListCall()
      raiseToast('success', 'Artist created successfully')
    }
  }, [createArtist])

  useEffect(() => {
    if (updateArtist && updateArtist.success) {
      artistListCall()
      raiseToast('success', 'Artist updated successfully')
    }
  }, [updateArtist])

  const handleStatus = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    editArtist({ status: !info.status }, info._id)
  }

  const addArtist = (payload) => {
    artistCreateCall({
      data: payload,
    })
    setOpenModal(false)
  }

  const editArtist = (payload, id) => {
    artistUpdateCall({
      params: {
        artist_id: id,
      },
      data: payload,
    })
    setOpenModal(false)
  }

  const handleEdit = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedArtist(info)
    setOpenModal(true)
  }

  const handleAdd = () => {
    if (!isCreateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedArtist({})
    setOpenModal(!openModal)
  }

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 24,
    },
    {
      header: 'Type',
      dataCell: (info) => info.artist_type,
      width: 22,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 22,
    },
    {
      header: 'Status',
      dataCell: (info) => (
        <CFormSwitch
          label={info.status ? 'Active' : 'Disabled'}
          checked={info.status}
          valid={info.status}
          value={info.status}
          onChange={() => handleStatus(info)}
          size="lg"
        />
      ),
      width: 20,
    },

    {
      header: <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />,
      dataCell: (info) => (
        <CIcon
          icon={cilPencil}
          style={{ cursor: 'pointer' }}
          size="lg"
          title="Edit"
          onClick={() => handleEdit(info)}
        />
      ),
      width: 7,
    },
  ]
  return (
    <>
      <h4>Artists</h4>
      <p>{`Manage your Artists`}</p>
      <SearchTable
        type={`Artist`}
        tableCardHeight={65}
        marginDisable={false}
        disableButton={false}
        buttonName={`+ Add`}
        buttonFunction={handleAdd}
        searchTerm={`name`}
        tableContent={artistList && artistList.data}
        tableConfig={tableConfig}
        createPermission={isCreateAllowed}
        disabledButtonTitle={defaultLangCheck ? '' : 'Adding Artist Available on Default Language'}
      />

      {openModal && (
        <ArtistCreateModal
          data={selectedArtist}
          openModal={openModal}
          artistTypes={artistType ? activeArray(artistType.data) : []}
          onCancel={() => {
            setOpenModal(false)
            setSelectedArtist({})
          }}
          setOpenModal={setOpenModal}
          addCallback={addArtist}
          updateCallback={editArtist}
          customMetadataMaster={customMetadataList ? activeArray(customMetadataList.data) : []}
        />
      )}
    </>
  )
}

export default Artists
